// Stolen directly from https://github.com/the-road-to-learn-react/use-combined-reducers
// because the NPM installed version has a build error which prevents us using it.
export const useCombinedReducers = (combinedReducers) => {
    // Global State
    const state = Object.keys(combinedReducers).reduce(
        (acc, key) => ({ ...acc, [key]: combinedReducers[key][0] }),
        {},
    );

    // Global Dispatch Function
    const dispatch = (action: any) => Object.keys(combinedReducers)
        .map((key) => combinedReducers[key][1])
        // eslint-disable-next-line @typescript-eslint/no-shadow
        .forEach((fn: (action: any) => void) => fn(action));

    return [state, dispatch];
};

/**
 * Remove any falsy value from an object
 */
export const removeFalsy = (obj: any) => {
    const newObj = {};
    Object.keys(obj).forEach((prop) => {
        if (obj[prop]) {
            newObj[prop] = obj[prop];
        }
    });
    return newObj;
};
